import { Component, input, Input } from '@angular/core';

@Component({
  selector: 'app-code-snippet',
  template: `
    <div class="code-snippet-container">
      <div class="code-header">
        <span class="language-tag">{{ codeLanguage }}</span>
        <button class="copy-button" (click)="copyToClipboard()">Copy</button>
      </div>
      <pre><code>{{ code }}</code></pre>
    </div>
  `,
  styleUrls: ['./code-snippet.component.scss']
})
export class CodeSnippetComponent {
  @Input() code: string = '';
  @Input() codeLanguage: string = ''; 

  copyToClipboard(): void {
    navigator.clipboard.writeText(this.code).then(
      () => alert('Code copied!'),
      () => alert('Failed to copy code.')
    );
  }
}
